
const systemKey = {
	O365: "o365",
	GOOGLE: "google",
	EXCHANGE2010: "exchange2010",
	EXCHANGE2013: "exchange2013"
}

const dateTimeFormat = {
	displayFullDateTime: "DD MMMM YYYY HH:mm",
	displayDate: "DD MMMM YYYY",
	displayTime: "HH:mm",

	apiFullDateTime: "YYYY-MM-DDTHH:mm:ss",
	apiDate: "YYYY-MM-DD"
}


export {
	systemKey,
	dateTimeFormat
}


// WEBPACK FOOTER //
// ./src/constant.js